var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dropdown',{staticClass:"disliked-dropdown",attrs:{"trigger":"click"},on:{"command":_vm.handleCommand}},[_vm._t("default"),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"self"}},[_vm._v("屏蔽本条内容")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }